import en from "./en";
import es from "./es";
import fr from "./fr";
import pt from "./pt";
import zh from "./zh";

import base_en from "./base_en";
import base_es from "./base_es";
import base_fr from "./base_fr";
import base_pt from "./base_pt";
import base_zh from "./base_zh";

const locale =
  navigator.language ||
  navigator?.languages[0] ||
  navigator.consumerLanguage ||
  "en";

const langs = {
  es: { base: base_es, lang: es },
  fr: { base: base_fr, lang: fr },
  pt: { base: base_pt, lang: pt },
  zh: { base: base_zh, lang: zh },
  en: { base: base_en, lang: en },
};

const getBaseLang = (lang) => {
  const current = (lang || locale).toLowerCase();

  const key = Object.keys(langs).find((k) => current.startsWith(k)) || "en";

  const { base, lang: langFile } = langs[key];

  return [{ ...base, ...langFile }, key];
};

function messages() {
  return getBaseLang(locale)[0];
}

export default {
  msgs: messages(),
  getBaseLang,
};
